// extracted by mini-css-extract-plugin
module.exports = {"legend":"legend_legend__1RTEu","disabled":"legend_disabled__3ihB7","nonBold":"legend_nonBold__3I7-d"};